export enum GoalType {
  EMISSIONS = "EMISSIONS",
  INTENSITY = "INTENSITY"
}
